<template>
  <li class="download-list-item" :class="fileIsApprovedClass">
    <div class="download-list-item__icon download-list-item__icon--primary">
      <i class="fa fa-2x" :class="getFileIcon"></i>
    </div>
    <div class="download-list-item__block">
      <p class="download-list-item__label">
        {{ file.file_name }}
        <span class="download-list-item__label--unapproved" v-if="!fileIsApproved"> - Unapproved</span>
        <span class="download-list-item__label--unapproved" v-else> - {{ fileLastUpdated | date($user.date_format_preference) }}</span>
      </p>
      <p v-if="fileIsApproved || userCanDownloadUnapprovedFile" class="download-list-item__link">
        <span @click="this.handleDownloadFileCallback">
          <i class="fa fa-cloud-download"></i> Download File
        </span>
        <ladda-button
          :click="this.handleApproveFileCallback"
          v-if="this.$userIsAdmin && !fileIsApproved"
          class="btn btn-primary btn-sm">
          Approve File
        </ladda-button>
        <span v-else-if="!fileIsApproved" class="download-list-item__link--secondary">
          - File is awaiting admin approval
        </span>
      </p>
    </div>
    <div v-if="canDeleteFile" class="download-list-item__icon download-list-item__icon--secondary">
      <i class="fa fa-times" :class="deleting ? 'download-list-item__icon--disabled cursor-not-allowed' : 'cursor-pointer'" @click="this.handleDeleteFileCallback"></i>
    </div>
  </li>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { apiUrl } from 'utils'
import moment from 'moment-timezone'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  props: {
    file: {
      required: true
    },
    booking: {
      required: true
    }
  },

  mixins: [OpportunityTracker],

  data () {
    return {
      deleting: false
    }
  },

  computed: {
    ...mapState('booking/file', ['files']),

    fileLastUpdated () {
      return moment.utc(this.file.updated_at).local()
    },

    getFileIcon () {
      switch (this.file.file_type) {
        case ('png'):
        case ('jpg'):
          return 'fa-file-image-o'
        case ('pdf'):
          return 'fa-file-pdf-o'
        case ('doc'):
        case ('docx'):
          return 'fa-file-word-o'
        case ('zip'):
          return 'fa-file-archive-o'
        case ('ppt'):
        case ('pptx'):
          return 'fa-file-powerpoint-o'
        case ('xls'):
        case ('xlsx'):
          return 'fa-file-excel-o'
        default:
          return 'fa-file-o'
      }
    },

    canDeleteFile () {
      return (this.$userIsAdmin || this.file.user_id === this.$user.id)
    },

    userCanDownloadUnapprovedFile () {
      if (this.file.user_id === this.$user.id) {
        return true
      }
      return this.$userIsAdmin
    },

    fileIsApproved () {
      if (this.booking.type === 'booking') {
        return true
      }
      return this.file.admin_approved
    },

    fileIsApprovedClass () {
      if (!this.fileIsApproved) {
        return 'download-list-item--unapproved'
      }
      return ''
    }
  },

  methods: {
    ...mapActions('booking/file', ['storeBookingFile', 'destroyFile', 'downloadFile', 'approveFile']),
    ...mapActions('message', ['removeFileFromMessages']),

    handleDeleteFileCallback () {
      if (this.deleting) {
        return
      }
      this.deleting = true
      return this.destroyFile({ id: this.file.booking_id, fileId: this.file.id }).then(response => {
        this.removeFileFromMessages({ fileId: this.file.id })
        this.deleting = false
        return response
      })
    },

    handleDownloadFileCallback () {
      this.trackEvent(this.analytics.V2.JobFileDownloadEvent)
      return this.downloadFile({ id: this.file.booking_id, file: this.file })
    },

    handleApproveFileCallback () {
      return this.approveFile(this.file.id)
    },

    getDownloadPhotoUrl () {
      return apiUrl(`bookings/${this.file.booking_id}/file/${this.file.file_hash}`)
    }
  }
}
</script>
